import { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { DataContext } from "../../context/DataContext";
import ClubLogin from "./ClubLogin";
import ClubShell from "./ClubShell";

export default function ClubRoutes() {
  const { clubData } = useContext(DataContext);
  const isClub = !!clubData?.club_info?.club_id;

  return (
    <Routes>
      <Route path="/club" element={isClub ? <Navigate to="/club/home" replace /> : <ClubLogin />} />
      <Route path="/club/*" element={isClub ? <ClubShell /> : <Navigate to="/club" replace />} />
    </Routes>
  );
}
